import _toArray from "@babel/runtime/helpers/toArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { filter, map } from '@beef/utils';
import { ScopeKeychain } from '@beefco/sdk-shared';
export var NodeTreeSlice = /*#__PURE__*/function () {
  function NodeTreeSlice(slice) {
    var _this = this;
    _classCallCheck(this, NodeTreeSlice);
    this.slice = slice;
    _defineProperty(this, "scopeKeychain", void 0);
    _defineProperty(this, "getNode", function (nodeId
    // scopeKeychain: ScopeKeychain,
    ) {
      var _this$slice$nodeId, _this$slice$nodeId2;
      if (!nodeId || !_this.slice[nodeId]) return {};
      // FIXME: remove or fix keychain
      var scopeKeychain = new ScopeKeychain();
      _this.setKeychain(scopeKeychain);
      return _objectSpread(_objectSpread({}, _this.slice[nodeId]), {}, {
        active: function (_ref) {
          var value = _ref.value,
            mapValue = _ref.mapValue;
          if (mapValue && scopeKeychain) {
            var _mapValue = _toArray(mapValue),
              expr = _mapValue[0],
              fields = _mapValue.slice(1);
            return _this.calculateExpr(expr, fields);
          }
          return value;
        }((_this$slice$nodeId = _this.slice[nodeId]) === null || _this$slice$nodeId === void 0 ? void 0 : _this$slice$nodeId.active),
        props: map(((_this$slice$nodeId2 = _this.slice[nodeId]) === null || _this$slice$nodeId2 === void 0 ? void 0 : _this$slice$nodeId2.props) || {}, function (_ref2) {
          var value = _ref2.value,
            mapValue = _ref2.mapValue;
          if (mapValue && scopeKeychain) {
            var _mapValue2 = _toArray(mapValue),
              expr = _mapValue2[0],
              fields = _mapValue2.slice(1);
            return _this.calculateExpr(expr, fields);
          }
          return value;
        })
      });
    });
    _defineProperty(this, "getRootIds", function () {
      return Object.keys(filter(_this.slice, function (node) {
        return node.parentId === null;
      }));
    });
  }
  _createClass(NodeTreeSlice, [{
    key: "setKeychain",
    value: function setKeychain(scopeKeychain) {
      this.scopeKeychain = scopeKeychain;
    }
  }, {
    key: "calculateExpr",
    value: function calculateExpr(expr, fields) {
      if (expr !== '$1') {
        throw Error('Expression parser not implemented, the only allowed mapValue expression is "$1".');
      }

      // TODO: replace with function execution
      return this.getScopeData(fields[0]);
    }
  }, {
    key: "getScopeData",
    value: function getScopeData(scopeNodeId) {
      var mapper = this.getNode(scopeNodeId); // , this.scopeKeychain as ScopeKeychain);
      if (mapper.componentId !== 'Mapper' || !Array.isArray(mapper.props.value) || !this.scopeKeychain) {
        throw Error('Could not retrieve scopeData. ScopeIdentifier must point to a Mapper');
      }
      return mapper.props.value[this.scopeKeychain.getScopeIndex(scopeNodeId)];
    }
  }]);
  return NodeTreeSlice;
}();